<section class="contacto">

  <!-- Encabezado -->
  <div class="container py-4">
    <h1 class="page-title">Contáctanos</h1>
    <p class="page-subtitle">
      Estamos para ayudarte — <span class="accent">resolvemos tus dudas</span> y te asesoramos.
    </p>
  </div>

  <!-- Cards -->
  <div class="container pb-5">
    <div class="row g-4">

      <!-- Izquierda: detalle -->
      <div class="col-12 col-lg-5">
        <div class="neo-card h-100">
          <div class="inner p-4 p-xl-5">
            <h5 class="card-heading">Contáctanos</h5>

            <div class="d-flex gap-3 mb-3 align-items-start">
              <span class="chip"> <i class="bi bi-map"></i> </span>
              <div>
                <div class="text-normal">
                  Harrington 367, La Calera de La Merced, Surquillo, Lima, Perú.
                </div>
                <small class="text-muted">15038</small>
              </div>
            </div>

            <div class="d-flex gap-3 mb-3 align-items-start">
              <span class="chip"><i class="bi bi-telephone"></i></span>
              <div class="d-flex flex-wrap gap-2">
                <a class="link- text-decoration-none text-normal" href="tel:+514998374">+51 4998374</a>
                <span class="text-muted">·</span>
                <a class="link- text-decoration-none text-normal" href="tel:+51981047718">+51 981047718</a>
              </div>
            </div>

            <div class="d-flex gap-3 mb-3 align-items-start">
              <span class="chip"><i class="bi bi-chat-text"></i></span>
              <a class="link-body-emphasis text-normal text-decoration-none" href="mailto:info@alphatecscientific.com">
                info_alphatecscientific.com
              </a>
            </div>

            <div class="d-flex gap-3 mb-4 align-items-start">
              <span class="chip"><i class="bi bi-globe"></i></span>
              <a class="link-body-emphasis text-decoration-none" href="https://www.alphatecscientific.com" target="_blank" rel="noopener">
                www.alphatecscientific.com
              </a>
            </div>

            <hr class="my-3 opacity-25">

            <div>
              <div class="text-uppercase small fw-semibold text-secondary mb-1">Horario</div>
              <div class=" text-normal">Lunes – Viernes, 9:00 am a 7:00 pm</div>
            </div>

            <!-- Botones pill -->
            <div class="d-flex flex-wrap gap-3 mt-4">
              <a class="btn btn-pill-primary shadow-soft" href="#productos">Explorar productos</a>
              <a class="btn btn-pill-outline" href="#categorias">Ver todas las categorías</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Derecha: formulario -->
      <div class="col-12 col-lg-7">
        <div class="neo-card h-100">
          <div class="inner p-4 p-xl-5">
            <h5 class="card-heading">Envíanos un mensaje</h5>

            <form [formGroup]="form" (ngSubmit)="submit()" novalidate class="row g-3">
              <div class="col-12 col-md-6">
                <label class="form-label">Tu nombre</label>
                <input type="text" class="form-control form-control"
                       [class.is-invalid]="controlInvalid('name')" placeholder="Nombre completo"  formControlName="name" autocomplete="name">
                <div class="invalid-feedback">Nombre obligatorio (mín. 2 caracteres).</div>
              </div>

              <div class="col-12 col-md-6">
                <label class="form-label">Tu email</label>
                <input type="email" class="form-control form-control"
                       [class.is-invalid]="controlInvalid('email')" placeholder="Correo electronico" formControlName="email" autocomplete="email">
                <div class="invalid-feedback">Ingresa un email válido.</div>
              </div>

              <div class="col-12">
                <label class="form-label">Asunto</label>
                <input type="text" class="form-control form-control"
                       [class.is-invalid]="controlInvalid('subject')" placeholder="Ingrese un asunto" formControlName="subject">
                <div class="invalid-feedback">Asunto obligatorio (mín. 3 caracteres).</div>
              </div>

              <div class="col-12">
                <label class="form-label">Tu mensaje (opcional)</label>
                <textarea rows="6" class="form-control" placeholder="Ingrese un mensaje" formControlName="message"></textarea>
              </div>

              <div class="col-12">
                <button class="btn btn-pill-primary w-100 fw-bold py-2"
                        [disabled]="isSubmitting || form.invalid">
                  <span *ngIf="!isSubmitting">Enviar</span>
                  <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  <span *ngIf="isSubmitting"> Enviando…</span>
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- MAPA al final: MISMO ancho que las cards -->
  <div class="container pb-4">
    <div class="row g-4">
      <div class="col-12">
        <div class="neo-card">
          <div class="inner p-0">
            <div class="map-shell rounded-4 overflow-hidden">
              <iframe src="https://www.google.com/maps?q=-12.1155385,-76.9998609&z=19&output=embed" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br><br>

</section>
